import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FormHelperText, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
    addBRPortfolioEntity,
    addExistingEntityToSubportfolio, addExistingEntityToSubportfolioFail,
    addSubportfolio, deleteSubportfolio,
    masqueradeAsCustomer, removeEntityFromSubportfolio
} from "../../../actions";
import BBExternalLink from "../accents/BBExternalLink";
import FormControl from "@material-ui/core/FormControl";
import {bbIsObject, bbShortenString, isFunctionComponent, mapObject} from "../../../util/bbHelpers";


const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();
    const {targetEntity, targetSubportfolio, closerCallback} = props;

    // console.log("Displaying add organization to portfolio form. Customer ID is", targetEntity)

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustAddSubportfolio} = useSelector(({breachrisk}) => breachrisk.appMisc);
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, loadingPortfolios, loadingAddBRPortfolioEntity, loadingAddBRPortfolioEntityError} = useSelector(({breachrisk}) => breachrisk);
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const entityName = targetEntity && targetEntity.name;
    const subportfolioName = targetSubportfolio && targetSubportfolio.name;

    console.log("BRPortfolioDeleteSubportfolioForm here is the subportfolio", targetSubportfolio);


    const dispatch = useDispatch();


    // const subportfolios = portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].portfolios ? portfolios[customerIdToUse].portfolios : null;
    //
    // const subportfolioMenuItems = subportfolios ? Object.values(subportfolios) : null;
    // if (subportfolioMenuItems) {
    //     subportfolioMenuItems.sort(function(a, b) {
    //         const textA = a.name.toUpperCase();
    //         const textB = b.name.toUpperCase();
    //         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    //     })
    // }

    // const [subportfolioId, setSubportfolioId] = useState(null);

    const clearForm = () => {
        // setSubportfolioName("");
        // setDescription("");
        document.getElementById('BRPortfolioRemoveEntityFromSubportfolioForm').reset();
    }


  useEffect(() => {
    if(didJustAddSubportfolio) {
        clearForm();
    }
  }, [dispatch, didJustAddSubportfolio]);

    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {

        if(targetSubportfolio && targetSubportfolio.id){
            dispatch(deleteSubportfolio(
                customerIdToUse,
                targetSubportfolio.id
            ));

            //close the dialog
            console.log("About to close the delete a portfolio group dialog");
            if(closerCallback && typeof closerCallback === 'function'){
                closerCallback();
            } else {
                console.warn("failed to close the remove entity from portfolio group dialog", "closerCallback", closerCallback, "isFunctionComponent(closerCallback)", isFunctionComponent(closerCallback), "typeof", typeof closerCallback)
            }
        } else {
            console.warn("attempted remove entity from portfolio but failed to meet initial checks before dispatch",  "targetSubportfolio", targetSubportfolio)
            // dispatch(addExistingEntityToSubportfolioFail(
            //     targetEntity,
            //     subportfolioId
            // ))
        }
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">

            <form id={"BRPortfolioRemoveEntityFromSubportfolioForm"} className={classes.root}>

                <h3>Are you sure you want to delete the portfolio group <strong>{subportfolioName}</strong>?</h3>
                <small>The companies in this group will still be available in the master portfolio.</small>
                <br/>

                    <div className="mb-3 d-flex align-items-center justify-content-between">

                        <Button onClick={handleSubmit(onSubmit)}
                                // disabled={!!errors.subportfolioId}
                                variant="contained" color="primary"
                                type="submit">
                            Remove Portfolio Group
                        </Button>
                    </div>

            </form>

        </div>
    );

}

export default Form